function removeQuotes(string) {
  let out = string;
  if (typeof string === 'string' || string instanceof String) {
    out = string.replace(/^['"]+|\s+|\\|(;\s?})+|['"]$/g, '');
  }
  return out;
}

function getBreakpoints() {
  let style = null;
  if (window.getComputedStyle && window.getComputedStyle(document.body, '::before')) {
    style = window.getComputedStyle(document.body, '::before');
    style = style.content;
  } else {
    window.getComputedStyle = function (el) {
      this.el = el;
      this.getPropertyValue = function (prop) {
        const re = /(-([a-z]){1})/g;
        let saneProp = prop;
        if (re.test(prop)) {
          saneProp = prop.replace(re, (...args) => args[2].toUpperCase());
        }
        return el.currentStyle[saneProp] ? el.currentStyle[saneProp] : null;
      };
      return this;
    };
    style = window.getComputedStyle(document.getElementsByTagName('head')[0]);
    style = style.getPropertyValue('font-family');
  }
  return JSON.parse(removeQuotes(style));
}

$(() => {
  window.Foundation.breakpoints = getBreakpoints();
});
